/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { ErrorDisplay } from "cms/shared/error_display";
import { BreadcrumbList } from "cms/shared/breadcrumb/breadcrumb-list";
import { useFetchBreadcrumbs } from "mydnv/components/shared/breadcrumb/use-fetch-breadcrumbs";

const Breadcrumb = (props) => {
    const webpage = props?.webpage;
    const model = props?.model;

    const { crumbs, error } = useFetchBreadcrumbs(webpage, model);

    if (error) {
        return (
            <ErrorDisplay error={error} />
        );
    }

    return (
        <BreadcrumbList crumbs={crumbs} />
    );
};

Breadcrumb.displayName = "Breadcrumb";
export { Breadcrumb };
